// extracted by mini-css-extract-plugin
export default {"toast_button___neutral":"CreateInviteButton_toast_button___neutral__J-42o"};